/*eslint-disable */

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import { VueEditor } from "vue2-editor";
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'update-algo-data-details',
  components: {
    VueEditor,
    Multiselect
  },
  props: ['updateAlgoDataID'],
  data () {
    return {
      categoryData: ['Allogenic Stem Cell Transplant',
      'Aplastic Anemia',
      'Autologous Stem Cell Transplant', 
      'Bladder Cancer', 
      'Bone Cancer', 
      'Breast Cancer', 
      'Cancer Drugs', 
      'Cervical Cancer', 
      'Clinical Oncology', 
      'Colon Cancer', 
      'Colorectal Cancer', 
      'Cytology', 
      'Drug Research', 
      'Endometrial cancer', 
      'Esophageal Cancer', 
      'Gastrointestinal Cancer', 
      'Glioblastoma', 
      'Gynaecological Cancer', 
      'Head and Neck Cancer', 
      'Immunotherapy', 
      'Kidney Cancer', 
      'Leukemia', 
      'Lung Cancer', 
      'Lymphoma', 
      'Medical Physics', 
      'Melanoma', 
      'Multiple Myeloma', 
      'Nuclear Medicine', 
      'Ovarian Cancer', 
      'Pancreatic Cancer', 
      'Pathology', 
      'Prostrate Cancer', 
      'Radiology', 
      'Radiotherapy', 
      'Retinoblastoma', 
      'Sarcoma', 
      'Testicular Cancer'
      ],
      submitted:false,
      title:'',
      comment:'',
      is_publish:false,
      category:'',
      file:null,
      uploadAttachmentName:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData: '',
      selectedFile:null,
      users:[],
      options:[],
      userList:null,
      userListResults:[],
      sentUserData:[],
      sharedDataWithUserList:[],
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserDetailsFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
  },
  mounted () {
    this.getSelfUserDetailsFun
    this.getAllUserListMethod()
    this.$store.dispatch('getAlgoDataDetailsByIdAction',{id:this.updateAlgoDataID}).then((res)=>{
      this.title = res.data.data.header
      this.category = res.data.data.category
      this.comment = res.data.data.data || ''
      this.selectedFile = res.data.data.data_file
      this.uploadAttachmentName = res.data.data.data_file_name
      this.is_publish = res.data.data.is_public
      this.sharedDataWithUserList = res.data.data.shared_users
      if(this.sharedDataWithUserList.length === 0) return;
      for(var i = 0; i < this.sharedDataWithUserList.length; i++){
        var users = {}
        users.first_name = this.sharedDataWithUserList[i].user.first_name
        users.last_name = this.sharedDataWithUserList[i].user.last_name
        users.email = this.sharedDataWithUserList[i].user.email
        users.id = this.sharedDataWithUserList[i].user.id
        // this.users.push(users)
      }
    }).catch((err)=>{
    })
  },
  methods: {
    getAllUserListMethod() {
     this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
       this.userList = res.data.data
       if(this.userList != undefined){
         this.userListResults = this.userList
         for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
         }
       }
     }).catch((err)=>{})
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.users.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    getAlgoDataListAgainMethod(){
      this.$store.dispatch('getAllPubAlgoDataListAction')
      this.$store.dispatch('getAlgoDataListAction')
    },
    selectedCategoryFun(val) {
      this.category = val
    },
    algoDataPublishedToggle() {
      if (this.is_publish === false) {
        this.is_publish = true
      } else {
        this.is_publish = false
      }
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
    cancelUploadingFileFun() {
      this.file = null
      this.files = null
      this.uploadAttachmentName = '';
    },
    updatelgoDataBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('header', this.title);
          formData.append('category', this.category);
          formData.append('data_file_name', this.uploadAttachmentName);
          formData.append('is_public', this.is_publish);
          if(this.file != null){
            formData.append('data_file', this.file);
          }
          if(this.comment != ''){
            formData.append('data', this.comment);
          }
          this.$store.dispatch('updateAlgoDataDetailsByIdAction',{data:{data:formData,id:this.updateAlgoDataID}})
            .then((res) => {  
              // if(this.users.length > 0 || this.sharedDataWithUserList.length > 0){
              //   this.algoDataSharedFun(this.updateAlgoDataID)
              // }
              toast.success(res.data.msg);
              this.submitted =  false
              this.closeUpdateAlgoDataPopup()
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeUpdateAlgoDataPopup(){
      bus.$emit('updateAlgoDataPopupBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
    algoDataSharedFun(algoID){
      for(var i = 0; i < this.users.length; i++){
        this.sentUserData.push(this.users[i].id)
      }
      var data = {
        algo_data:algoID,
        user:this.sentUserData
      }
      this.$store.dispatch('algoDataSharedWithUserAction', data)

    }
  },
  watch:{
    getSelfUserDetailsFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
  }
}